import { useMemo } from 'react'
import countryHelpers from 'i18n-iso-countries'

import { useCountries } from '@percent/cause-dashboard/common/hooks/useCountries/useCountries'
import type { Countries } from '@percent/cause-dashboard/services/countries/countriesService.types'
;(async () => {
  try {
    const localeData = await import('i18n-iso-countries/langs/en.json')
    const dataToRegister = localeData.default || localeData
    countryHelpers.registerLocale(dataToRegister)
  } catch (error) {
    console.error(error)
  }
})()

export const VOLUNTEER_DISALLOWED_ORG_OUNTRIES = ['CUB', 'IRN', 'PRK', 'MMR', 'RUS', 'SDN', 'SYR', 'UKR']

export interface UseVoluteeringCountriesResult {
  countries: Countries[]
  countryHelpers: typeof countryHelpers
}

export const useVoluteeringCountries = (): UseVoluteeringCountriesResult => {
  const countries = useCountries()

  const mappedCountries = useMemo(
    () => countries.filter(country => !VOLUNTEER_DISALLOWED_ORG_OUNTRIES.includes(country.code)),
    [countries]
  )

  return { countries: mappedCountries, countryHelpers }
}
